/*
 * ********************************************************************
 *  GlobePayroll Confidential
 *
 *  COPYRIGHT ©2016 by GlobePayroll. All Rights Reserved.
 *
 *   NOTICE:  All information contained herein is, and remains the property of GlobePayroll.
 *   The intellectual and technical concepts contained herein are proprietary to GlobePayroll
 *   and may be covered by U.S. and Foreign Patents, patents in process, and are protected by
 *   trade secret or copyright law.
 *   Dissemination of this information or reproduction of this material is strictly forbidden
 *   unless prior written permission is obtained from GlobePayroll.
 *  ********************************************************************
 *
 *  @author estelle.giuly
 *
 */
import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {TranslateModule} from '@ngx-translate/core';
import {CollapseModule} from 'ngx-bootstrap/collapse';
import {TabsModule} from 'ngx-bootstrap/tabs';

import {NavigationModule} from '../../navigation/navigation.module';
import {ApiModule} from '../api/api.module';
import {ContractEmployeeMenuModule} from '../contract-employee-menu/contract-employee-menu.module';
import {EmployeesListModule} from '../employees-list/employees-list.module';
import {EmployeesSharedModule} from '../employees/employees-shared.module';
import {ModalModule} from '../modal/modal.module';
import {UiModule} from '../ui/ui.module';
import {UserModule} from '../user/user.module';

import {ContractDataCardComponent} from './contract-data-card/contract-data-card.component';
import {ContractDataGroupMenuComponent} from './contract-data-group-menu/contract-data-group-menu.component';
import {ContractDataComponent} from './contract-data.component';

@NgModule({
  imports: [
    ApiModule,
    CommonModule,
    FormsModule,
    TranslateModule,
    ReactiveFormsModule,
    UiModule,
    EmployeesSharedModule,
    EmployeesListModule,
    TabsModule,
    ModalModule,
    NavigationModule,
    UserModule,
    ContractEmployeeMenuModule,
    CollapseModule
  ],
  declarations: [
    ContractDataCardComponent,
    ContractDataGroupMenuComponent,
    ContractDataComponent
  ],
  exports: [
    ContractDataCardComponent,
    ContractDataGroupMenuComponent,
    ContractDataComponent
  ]
})

export class ContractDataModule {
}
